
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Luo mittatietotaulu',
	'dashboard': 'Mittatietotaulu',
	'dashboardTemplate': 'Mittatietotaulun malli',
	'createAV': 'Luo',
	'createAvEditNameLabel': '1. Nimeä näkymä',
	'createAvSelectTemplateLabel': '2. Valitse mallipohja',
	'tabLayoutLabel': 'Välilehtiin jaettu malli',
	'infographicsLayoutLabel': 'Infografiikkamalli',
	'singlePageLayoutLabel': 'Yhden sivun malli',
	'customLayoutLabel': 'Mukautettu malli',
	'freeformTemplate': 'Vapaamuotoinen',
	'freeformTemplateDesc': 'Vapaamuotoisessa asettelussa visualisoinnit näkyvät näytön koosta riippumatta täsmälleen niin ja sen kokoisina kuin asetat ne näkymään. Muissa asetteluissa visualisointien koko ja sijainti säädetään näyttöön sopivaksi.',
	'NoTemplate': 'Vapaamuotoinen',
	'Template1': 'Tyhjä',
	'Template2': 'Otsikko, 1 sarake 2 riviä',
	'Template3': '2 ylhäällä 1 alhaalla',
	'Template4': '4 ylhäällä 1 alhaalla',
	'Template5': 'Alatunniste, 1 sarake 2 riviä',
	'Template6': '3 vasemmalla, yksi yhden päällä oikealla',
	'Template7': '4 vasemmalla, 3 yhden päällä oikealla',
	'Template8': '2 ylhäällä, 3 saraketta 2 riviä alhaalla',
	'Template9': '2 saraketta 2 riviä',
	'Template10': '1 sarake 2 riviä vasemmalla, 2 saraketta 2 riviä yhden päällä oikealla',
	'Template11': '3 saraketta 1 rivi ylhäällä, 1 sarake 2 riviä alhaalla',
	'Template12': '2 ylhäällä 1 alhaalla vasemmalla, 1 sarake 2 riviä oikealla',
	'Template13': 'Yksi vasemmalla, 1 sarake 2 riviä keskellä, 1 sarake 4 riviä oikealla',
	'Template22': '1 ylhäällä, 2 saraketta ja 2 riviä',
	'Template14': '1 vasemmalla 1 oikealla',
	'Template15': '1 ylhäällä, 1 vasemmalla 1 oikealla',
	'Template16': '1 vasemmalla 1 oikealla, 1 yhden päällä',
	'Template17': '1 ylhäällä, 1 vasemmalla 1 oikealla, 1 yhden päällä',
	'Template18': '1 ylhäällä, 1 vasemmalla 1 oikealla',
	'Template19': '1 ylhäällä, 2 vasemmalla 1 oikealla',
	'Template20': '1 ylhäällä, 2 saraketta 1 rivi',
	'Template21': '1 ylhäällä, 1 ylhäällä, 2 saraketta 1 rivi',
	'Template23': 'Tyhjä, jossa on pudotusalue',
	'Infographics1': 'Tyhjä',
	'Infographics2': '4 riviä',
	'Infographics3': '4 riviä ja otsikot',
	'Infographics4': '2 saraketta 4 riviä',
	'Infographics5': 'Suuri näyttö ylhäällä, 2 saraketta 2 riviä alhaalla',
	'Infographics6': '2 saraketta 4 riviä ja pystysuora väli',
	'Infographics7': '2 saraketta 4 riviä porrastettuna',
	'Infographics8': 'Tenniskenttä',
	'Infographics9': '3 saraketta 4 riviä',
	'Infographics10': '4 saraketta 8 riviä',
	'createAvDashboardLabel': 'Asettelu',
	'dashboard_template_save_success': 'Mittatietotaulun malli on tallennettu.',
	'dashboard_template_prefix': 'Malli: %{name}',
	'dashboard_template_filters_removed': 'Työalueen suodattimet on poistettu.',
	'createAvTabLabel': 'Välilehti',
	'createAvInfographicsLabel': 'Infografiikka',
	'createAvSinglepageLabel': 'Yksi sivu',
	'createAvCustomLabel': 'Mukautettu',
	'loadMoreLabel': 'Lataa lisää...',
	'backLabel': 'Takaisin',
	'addSourceLabel': 'Lisää lähde',
	'pinLabel': 'Kiinnitä',
	'errorLoadingDataSetMetaData': 'Metatietoja luettaessa on ilmennyt virhe',
	'errorLoadingDataSets': 'Tietojoukkojen luetteloa ladattaessa on ilmennyt virhe',
	'errorLoadingDataSet': 'Tietojoukon %{datasetName} metatietojen lataus epäonnistui. Lisätietoja saat pääkäyttäjältä.',
	'okButton': 'OK',
	'createButton': 'Luo',
	'cancelButton': 'Peruuta',
	'copyButton': 'Kopioi',
	'selectTemplateLabel': 'Valitse malli',
	'createBoardTitle': 'Mittatietotaulun luonti',
	'createBoardSubtitle': 'Valitse mittatietotaulun malli',
	'noSourcesSelectedLabel': 'Lähteitä ei ole valittu',
	'find_label': 'Etsi',
	'noDashboardFound': 'Mittatietotaulun nouto ei onnistu. Sitä ei enää ole, tai sinulla ei ole sen tarkasteluoikeuksia.',
	'errorLabel': 'Virhe',
	'defaultName': 'Uusi mittatietotaulu',
	'noDashboardCapability': 'Sinulla ei ole valtuuksia suorittaa mittatietotaulusovellusta',
	'noDashboardPermission': 'Käyttöoikeutesi eivät riitä tämän mittatietotaulun tarkasteluun.',
	'sourceNotFound': 'Visualisoinnin lataus ei onnistu, koska siihen liittyvä tietojoukko %{sourceName} ei ole käytettävissä',
	'cmDuplicateName': 'Järjestelmässä on jo tämänniminen objekti. Käytä jotakin toista nimeä',
	'cmEmptySelection': 'Mittatietotaulu on poistettu. Yritä tallentaa uutena mittatietotauluna.',
	'propTheme': 'Visuaalinen teema',
	'legacyThemeLabel': 'Vanha',
	'carbonGrey10Label': 'Carbon X, vaalea',
	'carbonGrey100Label': 'Carbon X, tumma',
	'titleTextLabel': 'Otsikko',
	'titleSmallTextLabel': 'Pieni otsikko',
	'subtitleTextLabel': 'Alaotsikko',
	'bodyTextLabel': 'Tekstiosa',
	'bodySmallTextLabel': 'Pieni tekstiosa',
	'captionTextLabel': 'Kuvateksti',
	'quoteTextLabel': 'Lainaus',
	'quoteSmallTextLabel': 'Pieni lainaus',
	'responsiveTextLabel': 'Sovita koko automaattisesti',
	'mediaWidgetLabel': 'Multimediasisältö',
	'webpageWidgetLabel': 'Web-sivu',
	'imageWidgetLabel': 'Kuva',
	'textWidgetLabel': 'Teksti',
	'notebookWidgetLabel': 'Muistikirja',
	'multipurposeWidgetLabel': 'Monitoiminen',
	'textPlaceHolder': 'Muokkaa tekstiä napsauttamalla',
	'titlePlaceHolder': 'Muokkaa otsikkoa napsauttamalla',
	'toggleEditModeLabel': 'Siirry muokkaukseen',
	'togglePreviewModeLabel': 'Siirry esikatseluun',
	'editDashboardCoachMarkTitle': 'Muokkaa mittatietotaulua',
	'editDashboardCoachMarkContents': 'Muokkaa tätä mittatietotaulua napsauttamalla kynäkuvaketta.',
	'addDataCoachMarkTitle': 'Lisää tietoja',
	'addDataDashboardCoachMarkContents': 'Vedä ja pudota tietoja tietonäytöstä mittatietotauluun.',
	'pageSelectWarning': 'Valitse välilehti.',
	'screenshot_label': 'Mittatietotaulu %{title}',
	'screenshot_label_tab': 'Mittatietotaulun%{title} välilehti %{tabName}',
	'dataAssetPropertiesLabel': 'Visualisoinnin ominaisuudet',
	'modelFilter': 'Suodatin',
	'invertSelectionToolTip': 'Muuta suodatinvalinnat käänteiseksi',
	'clearFilterValueToolTip': 'Tyhjennä suodattimen arvot',
	'invertFilterSelection': 'Muuta käänteiseksi',
	'clearTextFilterValue': 'Tyhjennä',
	'filterConditionLabel': 'Suodatusehto',
	'applyFilter': 'Ota suodatin käyttöön',
	'itemCountText': 'Valittu %{itemCount} kohde(tta)',
	'itemExcludeCountText': 'Jätetty pois %{itemCount} kohde(tta)',
	'moreMembers': 'Näytä lisää...',
	'searchHierarchyMembers': 'Etsi jäseniä haun avulla...',
	'propHideEmpty': 'Piilota tyhjä',
	'propColorOrder': 'Värien järjestys',
	'propElementColor': 'Visualisointielementin väri',
	'propLineColor': 'Viivan väri',
	'propLineAndSymbolColor': 'Viivan ja symbolin väri',
	'propColumnColor': 'Pylväskaavion väri',
	'propBarColor': 'Palkin väri',
	'propWordColor': 'Sanan väri',
	'propAreaColor': 'Alueen väri',
	'propRadialbarColor': 'Sädepalkin väri',
	'propColorPalettes': 'Väripaletit',
	'propDashboardColorPalette': 'Nykyinen mittatietotaulun paletti',
	'propNewDashboardPaletteLabel': 'Luo mukautettu mittatietotaulun paletti',
	'propDashboardChangePaletteLink': 'Vaihda mittatietotaulun paletti',
	'propHideLeafNode': 'Piilota lehtitason nimiöt',
	'propOpacity': 'Peittävyys',
	'propOpacityDescription': 'Tee objektista enemmän tai vähemmän läpikuultava. Kirjoita jokin arvo 0 - 100.',
	'addATab': 'Lisää uusi välilehti.',
	'propFredIsRed': 'Värien yhdenmukaisuus',
	'areaChartCaption': 'Aluekaavio',
	'areaChartDataSlot_categoriesLabel': 'Akselin nimiö',
	'areaChartDataSlot_valuesLabel': 'Arvo',
	'areaChartProp_colorPaletteLabel': 'Väripaletit',
	'areaChartProp_lineColorLabel': 'Alueen väri',
	'areaChartProp_interpolationLabel': 'Pyöristetyt viivat',
	'areaChartProp_interpolationDescription': 'Tietopisteitä yhdistävät viivat ovat kaarevia.',
	'areaChartProp_hideGridLinesLabel': 'Piilota ruudukkoviivat',
	'areaChartProp_hideGridLinesDescription': 'Piilota ruudukkoviivat',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'areaChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'areaChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'areaChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'areaChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'barChartCaption': 'Palkkikaavio',
	'barChartDataSlot_categoriesLabel': 'Akselin nimiö',
	'barChartDataSlot_valuesLabel': 'Arvo',
	'barChartProp_colorPaletteLabel': 'Väripaletit',
	'barChartProp_elementColorLabel': 'Palkin väri',
	'barChartProp_hideGridLinesLabel': 'Piilota ruudukkoviivat',
	'barChartProp_hideGridLinesDescription': 'Piilota ruudukkoviivat',
	'barChartProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'barChartProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'barChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'barChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'barChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'barChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'columnChartCaption': 'Pylväskaavio',
	'columnChartDataSlot_categoriesLabel': 'Akselin nimiö',
	'columnChartDataSlot_valuesLabel': 'Arvo',
	'columnChartProp_colorPaletteLabel': 'Väripaletit',
	'columnChartProp_elementColorLabel': 'Pylväskaavion väri',
	'columnChartProp_hideGridLinesLabel': 'Piilota ruudukkoviivat',
	'columnChartProp_hideGridLinesDescription': 'Piilota ruudukkoviivat',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'columnChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'columnChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'columnChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'columnChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'bubbleChartCaption': 'Kuplakaavio',
	'bubbleChartDataSlot_xAxisLabel': 'Vaaka-akseli',
	'bubbleChartDataSlot_yAxisLabel': 'Pystyakseli',
	'bubbleChartDataSlot_sizeLabel': 'Koon peruste',
	'bubbleChartDataSlot_colorLabel': 'Värin peruste',
	'bubbleChartProp_colorPaletteLabel': 'Väripaletit',
	'bubbleChartProp_hideGridLinesLabel': 'Piilota ruudukkoviivat',
	'bubbleChartProp_hideGridLinesDescription': 'Piilota ruudukkoviivat',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'bubbleChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'bubbleChartProp_hideLegendLabel': 'Piilota selite',
	'bubbleChartProp_hideLegendDescription': 'Piilota selite.',
	'bubbleChartProp_legendPositionLabel': 'Selitteen sijainti',
	'lineChartCaption': 'Viivakaavio',
	'lineChartDataSlot_categoriesLabel': 'Akselin nimiö',
	'lineChartDataSlot_valuesLabel': 'Arvo',
	'lineChartProp_colorPaletteLabel': 'Väripaletit',
	'lineChartProp_lineColorLabel': 'Viivan ja symbolin väri',
	'lineChartProp_symbolShapeLabel': 'Symbolin muoto',
	'lineChartProp_hideSymbolsLabel': 'Piilota symbolit',
	'lineChartProp_hideSymbolsDescription': 'Piilota symbolit',
	'lineChartProp_hideDataLinesLabel': 'Piilota viiva(t)',
	'lineChartProp_hideDataLinesDescription': 'Piilota viiva(t)',
	'lineChartProp_interpolationLabel': 'Pyöristetyt viivat',
	'lineChartProp_interpolationDescription': 'Tietopisteitä yhdistävät viivat ovat kaarevia.',
	'lineChartProp_hideGridLinesLabel': 'Piilota ruudukkoviivat',
	'lineChartProp_hideGridLinesDescription': 'Piilota ruudukkoviivat',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'lineChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'lineChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'lineChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'lineChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'packedBubbleChart1CatCaption': 'Kuplarykelmäkaavio',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Luokat',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Koon peruste',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Väripaletit',
	'packedBubbleChart1CatProp_elementColorLabel': 'Kuplan väri',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Piilota nimiö',
	'packedBubbleChart1CatProp_hideValueLabel': 'Piilota arvo',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Piilota tyhjä',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'heatChartCaption': 'Lämpökaavio',
	'heatChartDataSlot_valuesLabel': 'Lämmön peruste',
	'heatChartDataSlot_xAxisLabel': 'Vaaka-akseli',
	'heatChartDataSlot_yAxisLabel': 'Pystyakseli',
	'heatChartProp_colorPaletteLabel': 'Väripaletit',
	'heatChartProp_heatScalePaletteLabel': 'Värien järjestys',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'heatChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'heatChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'heatChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'heatChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'heatChartProp_hideLegendLabel': 'Piilota selite',
	'heatChartProp_hideLegendDescription': 'Piilota selite.',
	'heatChartProp_legendPositionLabel': 'Selitteen sijainti',
	'pieChartCaption': 'Ympyräkaavio',
	'pieChartDataSlot_categoriesLabel': 'Luokat',
	'pieChartDataSlot_valuesLabel': 'Arvo',
	'pieChartProp_colorPaletteLabel': 'Väripaletit',
	'pieChartProp_hideRadialValueLabel': 'Piilota arvo',
	'pieChartProp_pieAsDonutLabel': 'Näytä rengaskaaviona',
	'pieChartProp_pieAsDonutDescription': 'Näytä rengaskaaviona',
	'pieChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'pieChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'pieChartProp_hideLegendLabel': 'Piilota selite',
	'pieChartProp_hideLegendDescription': 'Piilota selite.',
	'pieChartProp_legendPositionLabel': 'Selitteen sijainti',
	'map1measureCaption': 'Kartta',
	'map1measureDataSlot_categoriesLabel': 'Alueet',
	'map1measureDataSlot_valuesLabel': 'Alueen lämpö',
	'map1measureProp_colorPaletteLabel': 'Väripaletit',
	'map1measureProp_heatScalePaletteLabel': 'Värien järjestys',
	'map1measureProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'map1measureProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'map1measureProp_suppressZerosLabel': 'Piilota tyhjä',
	'map1measureProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'map1measureProp_hideLegendLabel': 'Piilota selite',
	'map1measureProp_hideLegendDescription': 'Piilota selite.',
	'map1measureProp_legendPositionLabel': 'Selitteen sijainti',
	'radialChartCaption': 'Sädekaavio',
	'radialChartDataSlot_categoriesLabel': 'Luokat',
	'radialChartDataSlot_valuesLabel': 'Arvo',
	'radialChartProp_colorPaletteLabel': 'Väripaletit',
	'radialChartProp_elementColorLabel': 'Sädepalkin väri',
	'radialChartProp_hideRadialTitleLabel': 'Piilota otsikko',
	'radialChartProp_hideRadialValueLabel': 'Piilota arvo',
	'radialChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'radialChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'radialChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'radialChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'pointChart1catCaption': 'Pistekaavio',
	'pointChart1catDataSlot_valuesLabel': 'Arvo',
	'pointChart1catDataSlot_categoriesLabel': 'Akselin nimiö',
	'pointChart1catProp_colorPaletteLabel': 'Väripaletit',
	'pointChart1catProp_elementColorLabel': 'Muodon väri',
	'pointChart1catProp_symbolShapeLabel': 'Symbolin muoto',
	'pointChart1catProp_symbolFillLabel': 'Täytä muoto',
	'pointChart1catProp_symbolFillDescription': 'Näytä symbolien täyttöväri.',
	'pointChart1catProp_hideGridLinesLabel': 'Piilota ruudukkoviivat',
	'pointChart1catProp_hideGridLinesDescription': 'Piilota ruudukkoviivat',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'pointChart1catProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'pointChart1catProp_suppressZerosLabel': 'Piilota tyhjä',
	'pointChart1catProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'scatterPlotChartNoCatCaption': 'Hajontakaavio',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Vaaka-akseli',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Pystyakseli',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Väripaletit',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Elementin väri',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Symbolin muoto',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Täytä muoto',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Näytä symbolien täyttöväri.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Piilota ruudukkoviivat',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Piilota ruudukkoviivat',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'radialBarChartCaption': 'Sädepalkkikaavio',
	'radialBarChartDataSlot_categoriesLabel': 'Luokat',
	'radialBarChartDataSlot_valuesLabel': 'Arvo',
	'radialBarChartProp_colorPaletteLabel': 'Väripaletit',
	'radialBarChartProp_elementColorLabel': 'Sädepalkin väri',
	'radialBarChartProp_hideRadialTitleLabel': 'Piilota otsikko',
	'radialBarChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'radialBarChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'radialBarChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'radialBarChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'lineColumnComboChartCaption': 'Viiva- ja pylväskaavio',
	'lineColumnComboChartDataSlot_categoryLabel': 'Akselin nimiö',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Viivan arvo',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Pylvään arvo',
	'lineColumnComboChartProp_colorPaletteLabel': 'Väripaletit',
	'lineColumnComboChartProp_elementColorLabel': 'Pylväskaavion väri',
	'lineColumnComboChartProp_lineColorLabel': 'Viivan ja symbolin väri',
	'lineColumnComboChartProp_symbolShapeLabel': 'Symbolin muoto',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Piilota symbolit',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Piilota symbolit',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Piilota viiva(t)',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Piilota viiva(t)',
	'lineColumnComboChartProp_interpolationLabel': 'Pyöristetyt viivat',
	'lineColumnComboChartProp_interpolationDescription': 'Tietopisteitä yhdistävät viivat ovat kaarevia.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Piilota ruudukkoviivat',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Piilota ruudukkoviivat',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Piilota akselin otsikkonimiöt',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Piilota akselien otsikot.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'lineColumnComboChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'lineColumnComboChartProp_hideLegendLabel': 'Piilota selite',
	'lineColumnComboChartProp_hideLegendDescription': 'Piilota selite.',
	'lineColumnComboChartProp_legendPositionLabel': 'Selitteen sijainti',
	'summaryCaption': 'Yhteenveto',
	'areaName': 'Aluekaavio',
	'areaDescription': 'Aluekaavio',
	'areaDataSlot_colorLabel': 'Värin peruste',
	'areaDataSlot_valuesLabel': 'Arvo',
	'areaDataSlot_categoriesLabel': 'Akselin nimiö',
	'bubbleName': 'Kuplakaavio',
	'bubbleDescription': 'Kuplakaavio',
	'bubbleDataSlot_yAxisLabel': 'Pystyakseli',
	'bubbleDataSlot_xAxisLabel': 'Vaaka-akseli',
	'bubbleDataSlot_sizeLabel': 'Koon peruste',
	'bubbleDataSlot_colorLabel': 'Värin peruste',
	'clusterBarName': 'Palkkikaavio',
	'clusterBarDescription': 'Palkkikaavio',
	'clusterBarDataSlot_colorLabel': 'Värin peruste',
	'clusterBarDataSlot_valuesLabel': 'Arvo',
	'clusterBarDataSlot_categoriesLabel': 'Akselin nimiö',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Arvo',
	'clusterColumnName': 'Pylväskaavio',
	'clusterColumnDescription': 'Pylväskaavio',
	'clusterColumnDataSlot_colorLabel': 'Värin peruste',
	'clusterColumnDataSlot_valuesLabel': 'Arvo',
	'clusterColumnDataSlot_categoriesLabel': 'Akselin nimiö',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Arvo',
	'clusterLineName': 'Viivakaavio',
	'clusterLineDescription': 'Viivakaavio',
	'clusterLineDataSlot_colorLabel': 'Värin peruste',
	'clusterLineDataSlot_valuesLabel': 'Pystyakseli',
	'clusterLineDataSlot_categoriesLabel': 'Vaaka-akseli',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Arvo',
	'gridName': 'Ruudukko',
	'gridDescription': 'Ruudukko',
	'gridDataSlot_grid_colsLabel': 'Pylväskaavio',
	'heatName': 'Lämpökaavio',
	'heatDescription': 'Lämpökaavio',
	'heatDataSlot_yAxisLabel': 'Pystyakseli',
	'heatDataSlot_xAxisLabel': 'Vaaka-akseli',
	'heatDataSlot_valuesLabel': 'Lämmön peruste',
	'lineColumnComboName': 'Viiva- ja pylväskaavio',
	'lineColumnComboDescription': 'Viiva- ja pylväskaavio',
	'lineColumnComboDataSlot_lineValueLabel': 'Viivan arvo',
	'lineColumnComboDataSlot_categoryLabel': 'Akselin nimiö',
	'lineColumnComboDataSlot_columnValueLabel': 'Pylvään arvo',
	'mapName': 'Vanha kartta',
	'mapDescription': 'Vanha kartta',
	'mapDataSlot_sizeLabel': 'Pisteen koko',
	'mapDataSlot_valuesLabel': 'Alueen lämpö',
	'mapDataSlot_sizeHeatLabel': 'Pisteen lämpö',
	'mapDataSlot_categoriesLabel': 'Alueet',
	'packedBubbleName': 'Kuplarykelmäkaavio',
	'packedBubbleDescription': 'Kuplarykelmäkaavio',
	'packedBubbleDataSlot_sizeLabel': 'Koon peruste',
	'packedBubbleDataSlot_colorLabel': 'Värin peruste',
	'packedBubbleDataSlot_categoriesLabel': 'Luokat',
	'pieName': 'Ympyräkaavio',
	'pieDescription': 'Ympyräkaavio',
	'pieDataSlot_valuesLabel': 'Arvo',
	'pieDataSlot_categoriesLabel': 'Luokat',
	'playerName': 'Tietojen toistin',
	'playerDescription': 'Tietojen toistin',
	'playerDataSlot_categoriesLabel': 'Akselin nimiö',
	'pointName': 'Pistekaavio',
	'pointDescription': 'Pistekaavio',
	'pointDataSlot_colorLabel': 'Värin peruste',
	'pointDataSlot_valuesLabel': 'Arvo',
	'pointDataSlot_categoriesLabel': 'Akselin nimiö',
	'radialName': 'Sädekaavio',
	'radialDescription': 'Sädekaavio',
	'radialDataSlot_valuesLabel': 'Arvo',
	'radialDataSlot_maxSizeLabel': 'Enimmäisarvo',
	'radialDataSlot_categoriesLabel': 'Luokat',
	'radialBarName': 'Sädepalkkikaavio',
	'radialBarDescription': 'Sädepalkkikaavio',
	'radialBarDataSlot_valuesLabel': 'Arvo',
	'radialBarDataSlot_categoriesLabel': 'Luokat',
	'scatterPlotName': 'Hajontakaavio',
	'scatterPlotDescription': 'Hajontakaavio',
	'scatterPlotDataSlot_yAxisLabel': 'Pystyakseli',
	'scatterPlotDataSlot_xAxisLabel': 'Vaaka-akseli',
	'scatterPlotDataSlot_colorLabel': 'Värin peruste',
	'scatterPlotDataSlot_categoriesLabel': 'Pisteet',
	'stackedBarName': 'Pinottu palkkikaavio',
	'stackedBarDescription': 'Pinottu palkkikaavio',
	'stackedBarDataSlot_colorLabel': 'Värin peruste',
	'stackedBarDataSlot_valuesLabel': 'Arvo',
	'stackedBarDataSlot_categoriesLabel': 'Akselin nimiö',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Arvo',
	'stackedColumnName': 'Pinon palkki',
	'stackedColumnDescription': 'Pinon palkki',
	'stackedColumnDataSlot_colorLabel': 'Värin peruste',
	'stackedColumnDataSlot_valuesLabel': 'Arvo',
	'stackedColumnDataSlot_categoriesLabel': 'Akselin nimiö',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Arvo',
	'summaryChartName': 'Yhteenveto',
	'summaryChartDescription': 'Yhteenveto',
	'summaryChartDataSlot_valuesLabel': 'Arvo',
	'treeMapName': 'Rakennekaavio',
	'treeMapDescription': 'Rakennekaavio',
	'treeMapDataSlot_colorLabel': 'Lämmön peruste',
	'treeMapDataSlot_valuesLabel': 'Koon peruste',
	'treeMapDataSlot_categoriesLabel': 'Taso 1',
	'treeMapDataSlot_level3Label': 'Taso 3',
	'treeMapDataSlot_level2Label': 'Taso 2',
	'wordCloudName': 'Sanajoukko',
	'wordCloudDescription': 'Sanajoukko',
	'wordCloudDataSlot_colorLabel': 'Värin peruste',
	'wordCloudDataSlot_scaleLabel': 'Koon peruste',
	'wordCloudDataSlot_wordLabel': 'Sanat',
	'treeMap1Cat1MeasureChartCaption': 'Rakennekaavio',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Taso 1',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Koon peruste',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Väripaletit',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Väripaletit',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Väripaletit',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Väripaletit',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Väripaletit',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Väripaletit',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Piilota tyhjä',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Piilota selite',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Piilota selite.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Selitteen sijainti',
	'wordChart1Cat1MeasureCaption': 'Sanajoukko',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Sanat',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Koon peruste',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Väripaletit',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Sanan väri',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Säilytä akselin mittakaava',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Näytä aina akselien vähimmäis- ja enimmäisarvot.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Piilota tyhjä',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Piilota luokat, joihin ei liity arvoja.',
	'missingDataSetData': 'Tämän tietojoukon tiedot eivät ole käytettävissä. Päivitä tietojoukko, tai pyydä pääkäyttäjältä lähteen käyttöoikeus.',
	'hideShowSummaries': 'Piilota/näytä summat',
	'crosstabName': 'Ristiintaulukointi',
	'value_is_not_available': 'Ei käytettävissä',
	'swapRowsAndColumns': 'Vaihda rivit ja sarakkeet',
	'NoPinsCollected': 'Kiinnitettyjä visualisointeja ei ole',
	'pinSearchOld': 'Hae omia kiinnitettyjä omaisuuksia',
	'pinDeletedToast': 'Kiinnitys on poistettu',
	'pinAddedToast': 'Kiinnitys on lisätty omiin kiinnitettyihin omaisuuksiin',
	'pinRetrieveError': 'Yhden tai usean kiinnitetyn kohteen nouto ei onnistu. Yritä myöhemmin uudelleen.',
	'pinErrorTitle': 'Kiinnitysvirhe',
	'pinRemove': 'Poista kiinnitys',
	'deletePin': 'Poista kiinnitys',
	'dataset_time': 'time',
	'dataset_date': 'päivämäärä',
	'dataset_location': 'sijainti',
	'dataset_number': 'luku',
	'dataset_text': 'teksti',
	'widgetConditionalFormatLabel': 'Vaihda ehdollisen muotoilun ohjausobjektit',
	'deletePinConfirmationMessage': 'Haluatko varmasti poistaa tämän kiinnityksen? Toimintoa ei voi peruuttaa.',
	'deletePinConfirm': 'Vahvista poisto',
	'pinDeleteError': 'Yhden tai usean kiinnitetyn kohteen poisto ei onnistu. Yritä myöhemmin uudelleen.',
	'metadataPickerTitle': 'Luo tietojoukko',
	'moreTitle': 'Enemmän',
	'remove_slider_handle': 'Poista kahva',
	'missingFiltering': 'Puuttuva sarake:',
	'unSupportedPromptType': 'Kehoteskenaario ei ole tuettu.',
	'preAggregateLabel': 'Käytä kehotteen arvoja tietolähteestä',
	'postAggregateLabel': 'Käytä kehotteen arvoja raportissa',
	'preAggregateText': 'Alue käyttää tietolähteen arvoja, ei mittatietotaulussa näkyviä arvoja.',
	'tabName_general': 'Yleiset', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Tiedot',
	'tabName_textDetails': 'Tekstin tiedot', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Multimediasisällön tiedot', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Web-sivun tiedot', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Kuvan tiedot', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Visualisointi',
	'sectionName_canvas': 'Työalue',
	'sectionName_colorsAndThemes': 'Väri ja teema',
	'colorsAndThemes_legacyWarning': 'Nykyinen mittatietotaulu käyttää aiemman version mukaista teemaa. Jos teemaa muutetaan ja mittatietotaulu tallennetaan pysyvästi, aiemmat teemavalikoimat poistuvat käytöstä.',
	'sectionName_details': 'Tiedot',
	'sectionName_positionAndStyle': 'Sijainti ja tyyli',
	'sectionName_appearance': 'Ulkoasu', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Lisäasetukset',
	'sectionName_layout': 'Asettelu', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Välilehdet',
	'sectionName_tabTitle': 'Nimiö',
	'sectionName_tabBackground': 'Tausta',
	'addDataSourceDialogTitle': 'Lisää tietolähde',
	'addDataSourceDialogButtonLabel': 'Lisää',
	'shapesDoubleChevron': 'Kaksoisnuoli',
	'widgetsPanelTitle': 'Pienoisohjelmat',
	'widgetsPanelBasicsTab': 'Perusasetukset',
	'widgetsPanelImageLibraryTab': 'Kuvat',
	'widgetsPanelSectionStandard': 'Vakio',
	'widgetsPanelSectionAdvanced': 'Lisäasetukset',
	'widgetsPanelSectionShapes': 'Muodot',
	'customWidgetsTitle': 'Mukautetut pienoisohjelmat',
	'filterItemCanvasMove': 'Lisää työalueelle',
	'filterOverflowMenu_Global': 'Kaikkien välilehtien ylivuotovalikko',
	'filterOverflowMenu_Tab': 'Tämän välilehden ylivuotovalikko',
	'filterOverflowMenu_Item': 'Suodattimen ylivuotovalikko',
	'filterOverflowMenu_Single': 'Ylivuotovalikko',
	'filterItemEdit': 'Muokkaa suodattimen arvoja',
	'filterDeleteAllItems': 'Poista kaikki suodattimet',
	'filterClearAllItems': 'Tyhjennä kaikki suodattimet',
	'filterClearSelection': 'Tyhjennä suodatin',
	'filterPlayerMode': 'Näytä toistin',
	'filterStaticMode': 'Näytä luettelo',
	'filterInvertSelection': 'Muuta suodatin käänteiseksi',
	'filterIconLabel_Global': 'Kaikki välilehdet',
	'filterIconLabel_Single': 'Suodattimet',
	'filterIconLabel_Tab': 'Tämä välilehti',
	'filterIconTooltip_Global': 'Kaikki välilehdet',
	'filterIconTooltip_Tab': 'Tämä välilehti',
	'filterIconTooltip_Single': 'Suodattimet',
	'filterItemDelete': 'Poista suodatin',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'kaikki paitsi: %{from} - %{to}',
	'filterExcept': 'paitsi %{values}',
	'filterAll': 'Kaikki',
	'filterBlank': '(tyhjä)',
	'filterDisableRangeInvert': 'Ei käytettävissä, jos sarake on Kaikki välilehdet -suodattimessa.',
	'filterDisableHierarchyInvert': 'Ei käytettävissä, jos sarake on hierarkiasuodattimessa.',
	'filterSelectedOfTotal': '%{selected} / %{totalMembers}',
	'filter_date_before': 'Ennen arvoa %{to}',
	'filter_date_before_except': 'Ei ennen arvoa %{to}',
	'filter_date_after': 'Arvon %{from} jälkeen',
	'filter_date_after_except': 'Ei arvon %{from} jälkeen',
	'filter_date_between': 'Väliltä %{from} - %{to}',
	'filter_date_between_except': 'Ei väliltä %{from} - %{to}',
	'filter_drag_and_drop_all_tabs': 'Voit suodattaa kaikki välilehdet vetämällä ja pudottamalla tietoja tähän.',
	'filter_drag_and_drop_current_tab': 'Voit suodattaa tämän välilehden vetämällä ja pudottamalla tietoja tähän.',
	'filter_drag_and_drop_single_dock': 'Voit suodattaa vetämällä ja pudottamalla tietoja tähän.',
	'errMsgFilterItemGenericTitle': 'Suodattimen arvojen lataus ei onnistu',
	'widgetChromeRotate': 'Kierrä',
	'toolbarRegionLabel': 'Työkalurivi',
	'toolbarActionDelete': 'Poista',
	'toolbarActionGroup': 'Ryhmä',
	'toolbarActionUngroup': 'Pura ryhmä',
	'toolbarActionOrderToFront': 'Tuo eteen',
	'toolbarActionOrderToBack': 'Vie taakse',
	'toolbarActionEditTitle': 'Muokkaa otsikkoa',
	'toolbarActionWrapTitle': 'Rivitä otsikko',
	'toolbarActionPin': 'Kerää',
	'toolbarActionPinOld': 'Kiinnitä',
	'toolbarActionAlign': 'Tasaa',
	'alignWidgetLeft': 'Vasemmalla',
	'alignWidgetCenter': 'Keskelle',
	'alignWidgetRight': 'Oikealla',
	'alignWidgetTop': 'Ylhäällä',
	'alignWidgetMiddle': 'Keskellä',
	'alignWidgetBottom': 'Alhaalla',
	'toolbarChangeVisualization': 'Vaihda visualisointi',
	'multipurposeHeader': 'Valitse pienoisohjelman tyyppi',
	'multipurposePlaceholderText': 'Aloita valitsemalla pienoisohjelma.',
	'live_label': 'Kaavio',
	'filter_label': 'Suodatin',
	'one_named_live': 'Kaavio %{name}',
	'one_named_live_numbered': 'Kaavio %{name} (%{number})',
	'one_unknown_live': 'Kaavio',
	'one_unknown_live_numbered': 'Kaavio (%{number})',
	'few_live': '%{count} kaavion ryhmä',
	'many_live': '%{count} kaavion ryhmä',
	'one_custom': 'Mukautettu pienoisohjelma',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Suodatin %{name}',
	'one_named_filter_numbered': 'Suodatin  %{name} (%{number})',
	'one_unknown_filter': 'Suodatin',
	'one_unknown_filter_numbered': 'Suodatin (%{number})',
	'few_filter': '%{count} suodattimen ryhmä',
	'many_filter': '%{count} suodattimen ryhmä',
	'LIVE_bar_has_mapping': 'Palkkikaavio %{values}',
	'LIVE_bar_has_mapping_numbered': 'Palkkikaavio %{values} (%{number})',
	'LIVE_bar_opt_mapping': 'Palkkikaavio %{categories} - %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Palkkikaavio %{categories} - %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Tyhjä palkkikaavio',
	'LIVE_bar_no_mapping_numbered': 'Tyhjä palkkikaavio (%{number})',
	'LIVE_bar_named': 'Palkkikaavio %{name}',
	'LIVE_bar_named_numbered': 'Palkkikaavio %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Pinottu palkkikaavio %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Pinottu palkkikaavio %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Pinottu palkkikaavio %{categories} - %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Pinottu palkkikaavio %{categories} - %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Tyhjä pinottu palkkikaavio',
	'LIVE_stacked_bar_no_mapping_numbered': 'Tyhjä pinottu palkkikaavio (%{number})',
	'LIVE_stacked_bar_named': 'Pinottu palkkikaavio %{name}',
	'LIVE_stacked_bar_named_numbered': 'Pinottu palkkikaavio %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Kuplakaavio %{categories} - %{x} ja %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Kuplakaavio %{categories} - %{x} ja %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Tyhjä kuplakaavio',
	'LIVE_bubble_no_mapping_numbered': 'Tyhjä kuplakaavio (%{number})',
	'LIVE_bubble_named': 'Kuplakaavio %{name}',
	'LIVE_bubble_named_numbered': 'Kuplakaavio %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Yhdistelmäkaavio %{categories} - %{columnValue} ja %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Yhdistelmäkaavio %{categories} - %{columnValue} ja %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Tyhjä yhdistelmäkaavio',
	'LIVE_composite_no_mapping_numbered': 'Tyhjä yhdistelmäkaavio (%{number})',
	'LIVE_composite_named': 'Yhdistelmäkaavio %{name}',
	'LIVE_composite_named_numbered': 'Yhdistelmäkaavio %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Sääntörakenne %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Sääntörakenne %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Tyhjä sääntörakenne',
	'LIVE_decision_tree_no_mapping_numbered': 'Tyhjä sääntörakenne (%{number})',
	'LIVE_decision_tree_named': 'Sääntörakenne %{name}',
	'LIVE_decision_tree_named_numbered': 'Sääntörakenne %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Kuplarykelmäkaavio %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Kuplarykelmäkaavio %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Tyhjä kuplarykelmäkaavio',
	'LIVE_packed_bubble_no_mapping_numbered': 'Tyhjä kuplarykelmäkaavio (%{number})',
	'LIVE_packed_bubble_named': 'Kuplarykelmäkaavio %{name}',
	'LIVE_packed_bubble_named_numbered': 'Kuplarykelmäkaavio %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Ympyräkaavio %{categories} - %{values}',
	'LIVE_pie_has_mapping_numbered': 'Ympyräkaavio %{categories} - %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Tyhjä ympyräkaavio',
	'LIVE_pie_no_mapping_numbered': 'Tyhjä ympyräkaavio (%{number})',
	'LIVE_pie_named': 'Ympyräkaavio %{name}',
	'LIVE_pie_named_numbered': 'Ympyräkaavio %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Rengaskaavio %{categories} - %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Rengaskaavio %{categories} - %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Tyhjä rengaskaavio',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Tyhjä rengaskaavio (%{number})',
	'LIVE_pie_as_donut_named': 'Rengaskaavio %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Rengaskaavio %{name} (%{number})',
	'LIVE_line_has_mapping': 'Viivakaavio %{categories} - %{values}',
	'LIVE_line_has_mapping_numbered': 'Viivakaavio %{categories} - %{values} (%{number})',
	'LIVE_line_no_mapping': 'Tyhjä viivakaavio',
	'LIVE_line_no_mapping_numbered': 'Tyhjä viivakaavio (%{number})',
	'LIVE_line_named': 'Viivakaavio %{name}',
	'LIVE_line_named_numbered': 'Viivakaavio %{name} (%{number})',
	'LIVE_area_has_mapping': 'Aluekaavio %{categories} - %{values}',
	'LIVE_area_has_mapping_numbered': 'Aluekaavio %{categories} - %{values} (%{number})',
	'LIVE_area_no_mapping': 'Tyhjä aluekaavio',
	'LIVE_area_no_mapping_numbered': 'Tyhjä aluekaavio (%{number})',
	'LIVE_area_named': 'Aluekaavio %{name}',
	'LIVE_area_named_numbered': 'Aluekaavio %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Pinottu prosenttiarvoinen aluekaavio %{categories} - %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Pinottu prosenttiarvoinen aluekaavio %{categories} - %{values} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Tyhjä pinottu prosenttiarvoinen aluekaavio',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Tyhjä pinottu prosenttiarvoinen aluekaavio (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Pinottu prosenttiarvoinen aluekaavio %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Pinottu prosenttiarvoinen aluekaavio %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Lämpökaavio %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Lämpökaavio %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Tyhjä lämpökaavio',
	'LIVE_heatmap_no_mapping_numbered': 'Tyhjä lämpökaavio (%{number})',
	'LIVE_heatmap_named': 'Lämpökaavio %{name}',
	'LIVE_heatmap_named_numbered': 'Lämpökaavio %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Verkkokaavio %{categories} - %{series} ja %{values}',
	'LIVE_network_opt_mapping_numbered': 'Verkkokaavio %{categories} - %{series} ja %{values} (%{number})',
	'LIVE_network_has_mapping': 'Verkkokaavio  %{categories} - %{series}',
	'LIVE_network_has_mapping_numbered': 'Verkkokaavio  %{categories} - %{series} (%{number})',
	'LIVE_network_no_mapping': 'Tyhjä verkkokaavio',
	'LIVE_network_no_mapping_numbered': 'Tyhjä verkkokaavio (%{number})',
	'LIVE_network_named': 'Verkkokaavio %{name}',
	'LIVE_network_named_numbered': 'Verkkokaavio %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Sädepalkkikaavio %{categories} - %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Sädepalkkikaavio %{categories} - %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Sädepalkkikaavio %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Sädepalkkikaavio %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Tyhjä sädepalkkikaavio',
	'LIVE_radial_bar_no_mapping_numbered': 'Tyhjä sädepalkkikaavio (%{number})',
	'LIVE_radial_bar_named': 'Sädepalkkikaavio %{name}',
	'LIVE_radial_bar_named_numbered': 'Sädepalkkikaavio %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Spiraalikaavio %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Spiraalikaavio %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Tyhjä spiraalikaavio',
	'LIVE_spiral_no_mapping_numbered': 'Tyhjä spiraalikaavio (%{number})',
	'LIVE_spiral_named': 'Spiraalikaavio %{name}',
	'LIVE_spiral_named_numbered': 'Spiraalikaavio %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Rakennekaavio %{categories} - %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Rakennekaavio %{categories} - %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Tyhjä rakennekaavio',
	'LIVE_treemap_no_mapping_numbered': 'Tyhjä rakennekaavio (%{number})',
	'LIVE_treemap_named': 'Rakennekaavio %{name}',
	'LIVE_treemap_named_numbered': 'Rakennekaavio %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Sanajoukko %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Sanajoukko %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Tyhjä sanajoukko',
	'LIVE_wordcloud_no_mapping_numbered': 'Tyhjä sanajoukko (%{number})',
	'LIVE_wordcloud_named': 'Sanajoukko %{name}',
	'LIVE_wordcloud_named_numbered': 'Sanajoukko %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Tietojen toistin %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Tietojen toistin %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Tyhjä tietojen toistin',
	'LIVE_data_player_no_mapping_numbered': 'Tyhjä tietojen toistin (%{number})',
	'LIVE_data_player_named': 'Tietojen toistin %{name}',
	'LIVE_data_player_named_numbered': 'Tietojen toistin %{name} (%{number})',
	'LIVE_map_has_mapping': 'Kartta %{locations}',
	'LIVE_map_has_mapping_numbered': 'Kartta %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Tyhjä kartta',
	'LIVE_map_no_mapping_numbered': 'Tyhjä kartta (%{number})',
	'LIVE_map_named': 'Kartta %{name}',
	'LIVE_map_named_numbered': 'Kartta %{name} (%{number})',
	'LIVE_point_has_mapping': 'Pistekaavio %{categories} - %{values}',
	'LIVE_point_has_mapping_numbered': 'Pistekaavio %{categories} - %{values} (%{number})',
	'LIVE_point_no_mapping': 'Tyhjä pistekaavio',
	'LIVE_point_no_mapping_numbered': 'Tyhjä pistekaavio (%{number})',
	'LIVE_point_named': 'Pistekaavio %{name}',
	'LIVE_point_named_numbered': 'Pistekaavio %{name} (%{number})',
	'LIVE_column_has_mapping': 'Pylväskaavio %{values}',
	'LIVE_column_has_mapping_numbered': 'Pylväskaavio %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Pylväskaavio %{categories} - %{values}',
	'LIVE_column_opt_mapping_numbered': 'Pylväskaavio %{categories} - %{values} (%{number})',
	'LIVE_column_no_mapping': 'Tyhjä pylväskaavio',
	'LIVE_column_no_mapping_numbered': 'Tyhjä pylväskaavio (%{number})',
	'LIVE_column_named': 'Pylväskaavio %{name}',
	'LIVE_column_named_numbered': 'Pylväskaavio %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Pinottu pylväskaavio %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Pinottu pylväskaavio %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Pinottu pylväskaavio %{categories} - %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Pinottu pylväskaavio %{categories} - %{values} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Tyhjä pinottu pylväskaavio',
	'LIVE_stacked_column_no_mapping_numbered': 'Tyhjä pinottu  pylväskaavio (%{number})',
	'LIVE_stacked_column_named': 'Pinottu pylväskaavio %{name}',
	'LIVE_stacked_column_named_numbered': 'Pinottu pylväskaavio %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Hajontakaavio %{categories} - %{x} ja %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Hajontakaavio %{categories} - %{x} ja %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Hajontakaavio %{x} vs. %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Hajontakaavio %{x} vs. %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Tyhjä hajontakaavio',
	'LIVE_scatter_no_mapping_numbered': 'Tyhjä hajontakaavio (%{number})',
	'LIVE_scatter_named': 'Hajontakaavio %{name}',
	'LIVE_scatter_named_numbered': 'Hajontakaavio %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Vesiputouskaavio %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Vesiputouskaavio %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Tyhjä vesiputouskaavio',
	'LIVE_waterfall_no_mapping_numbered': 'Tyhjä vesiputouskaavio (%{number})',
	'LIVE_waterfall_named': 'Vesiputouskaavio %{name}',
	'LIVE_waterfall_named_numbered': 'Vesiputouskaavio %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Visualisointien muodostus',
	'LIVE_empty_visualization_hint_description': 'Vedä ja pudota sarakkeet tähän tai vasemmalla oleviin paikkoihin.',
	'LIVE_slots_required_field_description': '%{asterisk} ilmaisee pakollisen kentän',
	'LIVE_slots_drag_and_drop_description': 'Voit muodostaa visualisoinnin ja suodattaa sen vetämällä ja pudottamalla tiedot yllä oleviin paikkoihin.',
	'requiredField': 'Pakollinen kenttä',
	'fullScreenEnter': 'Siirry koko näytön tilaan',
	'fullScreenClose': 'Poistu koko näytön tilasta',
	'noExtraText_multipurpose': 'Monitoiminen paikkamerkki',
	'noExtraText_multipurpose_numbered': 'Monitoiminen paikkamerkki (%{number})',
	'one_placeholder_vis': 'Visualisoinnin paikkamerkki',
	'one_placeholder_vis_numbered': 'Visualisoinnin paikkamerkki (%{number})',
	'one_placeholder_text': 'Tekstin paikkamerkki',
	'one_placeholder_text_numbered': 'Tekstin paikkamerkki (%{number})',
	'few_placeholder_text': '%{count} tekstipaikkamerkin ryhmä',
	'many_placeholder_text': '%{count} tekstipaikkamerkin ryhmä',
	'filter_includesAll': 'Sisältää kaikki',
	'timeline_filter_moved_to': 'Aikajanan suodatin %{id} on siirretty aikaan %{time}',
	'timelineSettingsButton': 'Toistoasetukset',
	'autoPlay': 'Toista kaikki kohtaukset',
	'loop': 'Toista jatkuvasti',
	'noSceneTransitionLabel': 'Ei mitään',
	'sceneTransitionPropertyLabel': 'Kohtauksen siirto',
	'animatedPathSceneTransitionLabel': 'Animoitu polku',
	'sweepSceneTransitionLabel': 'Pyyhkäisy',
	'propAniAnimation': 'Animaatio',
	'propAniTypeEntrance': 'Aloitusanimaatio',
	'propAniDirectionIn': 'Aloituksen suunta',
	'propAniTypeExit': 'Lopetusanimaatio',
	'propAniDirectionOut': 'Lopetuksen suunta',
	'propAniDirection': 'Suunta',
	'timelineAnimationProperties': 'Avaa animaation ominaisuudet',
	'editStoryCoachMarkTitle': 'Muokkaa tarinaa',
	'editStoryCoachMarkContents': 'Muokkaa tarinaa napsauttamalla kynäkuvaketta.',
	'addDataStoryCoachMarkContents': 'Vedä ja pudota tietoja tietonäytöstä tarinaan.',
	'expandSceneCoachmarkTitle': 'Avaa aikajana',
	'expandSceneCoachmarkContents': 'Voit animoida kohtauksen säätämällä objektin näkyvyyttä ajan ja keston perusteella.',
	'overviewCoachmarkTitle': 'Kohtausten yleiskuvaus',
	'overviewCoachmarkContents': 'Käytä kohtausten yleiskuvausta tarinan alussa ja lopussa näyttääksesi yleiskuvan kaikista kohtauksista. Voit vaihtaa kohtauksen paikkaa toisen kohtauksen kanssa napsauttamalla ja vetämällä kohtausta kohtausten yleiskuvauksessa. Voit myös näyttää tai piilottaa kohtausten yleiskuvauksen tarinan ominaisuuksissa.',
	'animatedPathCoachmarkTitle': 'Animoitu polku',
	'animatedPathCoachmarkContents': 'Voit animoida objektin kohtauksesta toiseen kopioimalla ensin objektin sisältämän kohtauksen. Sitten siirrä, kierrä tai muuta objektin kokoa uudessa kohtauksessa.',
	'tabName_animation': 'Animaatio',
	'textWidgetIconPlaceholderText': 'Lisää teksti napsauttamalla tätä',
	'buildVisHeader': 'Luo visualisointi',
	'visIconPlaceholderText': 'Voit luoda visualisoinnin vetämällä ja pudottamalla kenttiä',
	'launchNewExplore': 'Uusi tutkimus',
	'addTo': 'Lisää kohteeseen',
	'addToExisting': 'Lisää aiemmin luotuun...',
	'exploreData': 'Selaa',
	'explore_remove_widget_styles': 'Mukautetut visualisoinnin ominaisuudet, kuten väriasetukset, eivät säily tutkimuksessasi.',
	'editNotebook': 'Muokkaa widget-objektia',
	'thumbnails_error_fetching': 'Pienoiskuvien noudossa on ilmennyt virhe.',
	'copy': '%{count} omaisuus/omaisuutta on kopioitu',
	'specConvertErr': 'Mittatietotaulun määritystä liitettäessä tai muunnettaessa on ilmennyt virhe',
	'specCopyErr': 'Mittatietotaulun määritystä kopioitaessa on ilmennyt virhe',
	'pasteNotSupportedErr': 'Liittäminen kohteesta %{name} ei ole tuettu.',
	'reportParam': 'raportti',
	'filterWidgetCopyWarn': 'Suodattimen visualisointia ei kopioitu, koska suodattimet eivät ole toistaiseksi tuettuja.',
	'upgradingDashboard': 'Kohteen %{name} päivitys kohdetta %{version} varten...',
	'upgradeComplete': 'Päivitys on valmis',
	'individualTabProperties': 'Yksittäisen välilehden ominaisuudet',
	'propMasterTabStylesLabel': 'Päävälilehden tyyli',
	'propTabPosition': 'Välilehden sijainti',
	'propTabTitle': 'Otsikko',
	'propTabBackgroundColor': 'Täyttöväri',
	'propTabTextColor': 'Otsikon väri',
	'propTabSelectedBarColor': 'Valitun palkin väri',
	'propTabRestoreDefaults': 'Palauta oletukset',
	'propIndividualTabStylesLabel': 'Yksittäisen välilehden tyyli',
	'propIndividualTabStylesAriaLabel': 'Avaa yksittäisen välilehden tyyliominaisuudet',
	'propTabIconPosition': 'Kuvakkeen sijainti',
	'propLeftTitle': 'Otsikon vasemmalla puolella',
	'propRightTitle': 'Otsikon oikealla puolella',
	'propTopTitle': 'Otsikon yläpuolella',
	'propBottomTitle': 'Otsikon alapuolella',
	'propTabIconLabel': 'Visuaalinen',
	'propTabIcon': 'Kuvake',
	'propTabIconColor': 'Kuvakkeen väri',
	'no_icon': 'Tyhjä',
	'announcement': 'Ilmoitus',
	'api': 'API',
	'archive': 'Arkistoi',
	'asset': 'Omaisuus',
	'attachment': 'Liite',
	'audio': 'Äänet',
	'bee': 'Mehiläinen',
	'blog': 'Verkkoloki',
	'bookmark': 'Kirjanmerkki',
	'calendar': 'Kalenteri',
	'camera': 'Kamera',
	'capability': 'Ominaisuus',
	'catalog': 'Luettelo',
	'chat_message': 'Keskusteluviesti',
	'checkout_cart': 'Ostoskori',
	'client': 'Työasema',
	'clock': 'Kello',
	'cloud': 'Pilvinen',
	'code': 'Koodi',
	'data_quality': 'Tietojen laatu',
	'folder': 'Kansiot',
	'forum': 'Keskusteluryhmä',
	'glasses': 'Lasit',
	'group': 'Ryhmä',
	'hat': 'Hattu',
	'headphone': 'Kuuloke',
	'hills': 'Kukkulat',
	'home': 'Kotisivu',
	'idea': 'Idea',
	'image': 'Kuva',
	'inventory': 'Varasto',
	'like': 'Pidä',
	'link': 'Linkki',
	'location': 'Sijainti',
	'manage': 'Hallitse',
	'pen': 'Kynä',
	'mobile_phone': 'Matkapuhelin',
	'music': 'Musiikki',
	'notifications': 'Ilmoitukset',
	'paint': 'Maali',
	'payment': 'Maksu',
	'password_key': 'Salasanan avain',
	'people': 'Ihmisiä',
	'person': 'Henkilö',
	'phone': 'Puhelin',
	'pin': 'Kiinnitä',
	'print': 'Tulosta',
	'recording': 'Nauhoitus',
	'repository': 'Tietosäilö',
	'role': 'Rooli',
	'search': 'Hae',
	'properties': 'Ominaisuudet',
	'speaker': 'Puhuja',
	'star': 'Tähti',
	'tag': 'Tunniste',
	'thumbs_up': 'Peukalot ylöspäin',
	'thumbs_down': 'Peukalot alaspäin',
	'tools': 'Työkalut',
	'traffic': 'Liikenne',
	'trash': 'Roskakori',
	'twitter': 'Twitter',
	'unknown': 'Tuntematon',
	'user': 'Käyttäjä',
	'venn_diagram': 'Venn-kaavio',
	'video': 'Video',
	'view': 'Näkymä',
	'warning': 'Varoitus',
	'watch': 'Katso',
	'watson': 'Watson',
	'wikis': 'Wikit',
	'workspace': 'Työtila',
	'world': 'Maailma',
	'OnLoadFilterModifierDatasourceMismatch': 'Suodattimia ei käytetä kohteessa, koska mittatietotauluilla on eri lähteet.',
	'OnLoadFilterModifierColumnMismatch': 'Ainakin yksi suodatin jäi käyttämättä, koska vastaavia sarakkeita ei löytynyt.',
	'eventGroupButtonLabel': 'Näytä pienoisohjelmien yhteydet',
	'dockToolbar': 'Kiinnitä työkalurivi',
	'undockToolbar': 'Pura työkalurivin kiinnitys',
	'propShowTitle': 'Näytä otsikko'
});
